var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 95,
    viewBox: "0 0 92 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD15C",
    fillRule: "nonzero",
    d: "M72.756 19.566H89v12.42c0 8.914-7.293 16.177-16.244 16.177h-2.115c-3.062 6.74-9.204 11.796-16.633 13.38v10.145h5.838a3.243 3.243 0 0 1 3.249 3.235v4.247h4.974v15.183H29.948V79.17h4.974v-4.247a3.243 3.243 0 0 1 3.249-3.235h5.82V61.543c-7.428-1.584-13.57-6.64-16.632-13.38h-2.115C16.293 48.163 9 40.9 9 31.986v-12.42h16.244V12h47.479v7.566h.033zM25.328 39.973a23.337 23.337 0 0 1-.05-1.55V27.756h-8.02v4.23c0 4.398 3.603 7.987 8.02 7.987h.05zm17.09 39.972v8.14h13.198v-8.14H42.418zm30.338-52.189v10.667c0 .522-.017 1.028-.05 1.55h.05c4.417 0 8.02-3.589 8.02-7.987v-4.23h-8.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8B64C",
    fillRule: "nonzero",
    d: "M31.745 18.275h34.51v19.607c0 9.53-7.725 17.255-17.255 17.255s-17.255-7.725-17.255-17.255V18.275z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40596B",
    d: "M81.982 86.732a.404.404 0 0 0 0 .506l3.79 4.6a.615.615 0 0 1-.474 1.011H71.745V81.02h13.587c.525 0 .812.607.474.995l-3.824 4.718zM11.522 82.03l3.79 4.601a.404.404 0 0 1 0 .506l-3.824 4.718a.611.611 0 0 0 .474.994h13.604V81.02H12.013a.625.625 0 0 0-.49 1.012z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M58.5 30.935l-6.363-.455-2.403-5.881c-.456-1.112-2.03-1.112-2.487 0l-2.403 5.881-6.362.455c-1.201.084-1.692 1.584-.761 2.342l4.873 4.095-1.523 6.168c-.287 1.163.982 2.09 2.014 1.45l5.414-3.354 5.415 3.353c1.015.624 2.301-.286 2.013-1.45l-1.522-6.167 4.873-4.095c.896-.775.423-2.258-.779-2.342z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F99830",
    fillRule: "nonzero",
    d: "M19.45 14.367c-1.286-.244-3.52-1.84-2.76-6.136.278-1.569-.064-1.697-1.925-2.116-1.818-.41-4.566-1.028-4.763-4.841A1.215 1.215 0 0 1 11.159.002a1.216 1.216 0 0 1 1.283 1.147c.098 1.897 1 2.183 2.864 2.603 1.675.377 4.478 1.009 3.79 4.897-.52 2.948.8 3.335.813 3.338.663.125 1.098.76.971 1.417a1.221 1.221 0 0 1-1.43.963zM82.876 63.014c-.367-1.257.042-3.972 4.214-5.245 1.523-.465 1.483-.828 1.011-2.676-.46-1.806-1.156-4.535 2.151-6.442a1.215 1.215 0 0 1 1.66.454c.337.586.138 1.33-.441 1.663-1.645.95-1.491 1.882-1.019 3.734.425 1.664 1.135 4.449-2.642 5.601-2.864.874-2.61 2.226-2.605 2.24a1.212 1.212 0 0 1-.822 1.508 1.221 1.221 0 0 1-1.507-.837z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.806,
    cy: 9.477,
    fill: "#00CDB3",
    fillRule: "nonzero",
    rx: 1.586,
    ry: 1.573
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.806,
    cy: 56.477,
    fill: "#57BAE5",
    fillRule: "nonzero",
    rx: 1.586,
    ry: 1.573
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.781,
    cy: 66.251,
    fill: "#FFCA54",
    fillRule: "nonzero",
    rx: 1.586,
    ry: 1.573
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.781,
    cy: 56.251,
    fill: "#FF4B4E",
    fillRule: "nonzero",
    rx: 1.586,
    ry: 1.573
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.781,
    cy: 6.251,
    fill: "#FFCA54",
    fillRule: "nonzero",
    rx: 1.586,
    ry: 1.573
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00CDB3",
    fillRule: "nonzero",
    d: "M3.232 34.504l-2.258-.905A1.208 1.208 0 0 1 .3 32.022c.253-.62.965-.92 1.59-.67l2.258.906c.625.25.927.957.674 1.577-.254.623-.969.919-1.59.669z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#57BAE5",
    fillRule: "nonzero",
    d: "M67.753 68.642l-2.258-.906a1.208 1.208 0 0 1-.674-1.577c.252-.62.965-.92 1.59-.669l2.258.905c.625.251.927.957.674 1.578-.25.615-.958.921-1.59.669z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.0730093f44bc61a4d9af406f11047ce2.svg";
export { ForwardRef as ReactComponent };